<script>
/**
 * 回到顶部（自 vancheen-b2b 的 BackToTop.vue 移植为 Vue 2 版本）
 * 使用 Element UI 的 el-backtop（2.13+ 支持），外观由 nh-theme.css 还原。
 */
import NhSvgIcon from './NhSvgIcon.vue'

export default {
  name: 'NhBackToTop',
  components: { NhSvgIcon }
}
</script>

<template>
  <el-backtop class="wb-backtop" :right="22" :bottom="22" :visibility-height="600">
    <NhSvgIcon name="arrowUp" />
  </el-backtop>
</template>
